"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var RegistrationSuccessComponent = /** @class */ (function () {
    function RegistrationSuccessComponent() {
    }
    RegistrationSuccessComponent.prototype.ngOnInit = function () {
    };
    return RegistrationSuccessComponent;
}());
exports.RegistrationSuccessComponent = RegistrationSuccessComponent;
